import React, { createContext, useContext, useState } from 'react';

// Create a context for the address
const AddressContext = createContext();

// Create a provider component
export const AddressProvider = ({ children }) => {
  const [address, setAddress] = useState({
    line_1: '',
    line_2: '',
    line_3: '',
    post_town: '',
    postcode: '',
    country: 'UK', // Default country set to UK
  });

  return (
    <AddressContext.Provider value={{ address, setAddress }}>
      {children}
    </AddressContext.Provider>
  );
};

// Create a custom hook to use the address context
export const useAddress = () => {
  const context = useContext(AddressContext);
  if (!context) {
    throw new Error('useAddress must be used within an AddressProvider');
  }
  return context;
};
